import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = guest, object = authed
    const [token, setToken] = useState(() => localStorage.getItem("ls39_token") || null);

    useEffect(() => {
        if (!token) {
            setUser(false);
            return;
        }
        api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem("ls39_token");
                setUser(false);
            });
    }, [token]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.token) {
                localStorage.setItem("ls39_token", data.token);
                setToken(data.token);
            }
            setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_) {}
        localStorage.removeItem("ls39_token");
        setToken(null);
        setUser(false);
    };

    const authHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});

    return (
        <AuthContext.Provider value={{ user, login, logout, authHeaders, token }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
